import React from 'react'
import { useDispatch } from 'react-redux'

import {
  Button,
  Center,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { hideModal } from '@/stores/ui/modalSlice'

const MessageModal = ({ title = 'Welcome', message = '' }) => {
  const dispatch = useDispatch()

  const closeModal = () => {
    dispatch(hideModal())
  }

  return (
    <Modal isOpen={true} onClose={closeModal} size="xl" scrollBehavior={'inside'}>
      <ModalOverlay />
      <ModalContent maxW="50%">
        <ModalHeader>
          <Center>
            <Heading>{title}</Heading>
          </Center>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex justifyContent={'center'}>{message}</Flex>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="gray" onClick={closeModal}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default MessageModal
